import { SpecificDateTimeFormatOptions } from '@intlify/core-base'

const narrow: SpecificDateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}

const short: SpecificDateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}

const longDate: SpecificDateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}

const time: SpecificDateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
}

const long: SpecificDateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  weekday: 'short',
  hour: 'numeric',
  minute: 'numeric',
}

type DateTimeSchema = {
  narrow: DateTimeNarrow
  short: DateTimeShort
  long: DateTimeLong
  longDate: DateLong
  time: TimeShort
}

export type DateTimeNarrow = typeof narrow
export type DateTimeShort = typeof short
export type DateLong = typeof longDate
export type TimeShort = typeof time
export type DateTimeLong = typeof long

/**
 * For each locale we generate same set of date formatters
 */
export const datetimeFormats = (): DateTimeSchema => {
  return { narrow, short, long, longDate, time }
}
